import { render, staticRenderFns } from "./OptionPill.vue?vue&type=template&id=5eaa80cc&"
import script from "./OptionPill.vue?vue&type=script&lang=js&"
export * from "./OptionPill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports